import { Typography } from "@hellocarbo/lasagne";
import Card from "@ui/Card";
import { PieChartRef } from "@ui/PieChart";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";

import { Review } from "@/types";
import { formatCarbon } from "@/utils/carbon";

import ReviewCategoriesList, {
  ReviewCategoriesListRef,
} from "./ReviewCategoriesList";
import ReviewPie from "./ReviewPie";

function CarbonEmissionPanel({ data }: { data: Review }) {
  const { reviewId, admin } = useParams();
  const { t } = useTranslation(["common", "review", "formatter"]);

  const chartRef = useRef<PieChartRef>(null);
  const listRef = useRef<ReviewCategoriesListRef>(null);

  const { review_categories: reviewCategoriesData } = data;

  const handleListHover = (key: string | undefined) => {
    listRef.current?.highlight(key);
  };
  const handleChartHover = (key: string | undefined) => {
    chartRef.current?.highlight(key);
  };
  const handleChartClick = (key: string | undefined) => {
    const reviewCategoryId = reviewCategoriesData.find(
      ({ key: reviewCategoryKey }) => reviewCategoryKey === key
    )?.id;
    if (!reviewCategoryId) {
      return;
    }

    const linkUrl = `/reviews/${reviewId}/review_categories/${reviewCategoryId}${
      admin ? "/admin" : ""
    }`;
    window.location.assign(linkUrl);
  };

  const { formattedCarbon: formattedCarbonTotal, unit: totalUnit } =
    formatCarbon(t, data.carbon);

  return (
    <Card>
      <Typography step="2" as="h2" autoSpacing>
        {t("review:carbonEmissions.title")}
      </Typography>
      <Typography className="mb-lg">
        {t("review:carbonEmissions.description")}
      </Typography>
      <div className="grid w-full justify-self-center xl:w-3/4 xl:grid-cols-[1fr_2fr]">
        <div className="mx-auto size-[18rem]">
          <ReviewPie
            data={reviewCategoriesData}
            title={formattedCarbonTotal}
            titleSubText={t(`common:unit.${totalUnit}`)}
            chartRef={chartRef}
            onHover={handleListHover}
            onClick={handleChartClick}
          />
        </div>
        <div className="w-full grow">
          <ReviewCategoriesList
            review={data}
            ref={listRef}
            onHover={handleChartHover}
          />
        </div>
      </div>
    </Card>
  );
}

export default CarbonEmissionPanel;
